import { render } from "./ImportSynchroPopup.vue?vue&type=template&id=0f584489&scoped=true&ts=true"
import script from "./ImportSynchroPopup.vue?vue&type=script&lang=ts"
export * from "./ImportSynchroPopup.vue?vue&type=script&lang=ts"

import "./ImportSynchroPopup.vue?vue&type=style&index=0&id=0f584489&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f584489"]])

export default __exports__